/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-imports */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Form, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faTruck } from "@fortawesome/free-solid-svg-icons";

const TrackingCodeButton = ({ trackingCode }) => (
  <Button
    variant="success"
    className="w-100 my-2"
    disabled={String(trackingCode).trim() === ""}
    onClick={() => {
      const code = String(trackingCode).trim();
      if (!code) return;
      const url = `https://parcelsapp.com/it/tracking/${encodeURIComponent(code)}`;
      window.open(url, "_blank", "noopener,noreferrer");
    }}
    title="Tracking"
  >
    <FontAwesomeIcon icon={faTruck} className="svg-icon-white" style={{ marginRight: "0.5rem" }} />
    <span className="text-white">Visualizza Tracking</span>
  </Button>
);

const TrackingCodeInput = ({ canManage, row, isRowLoading, updateTrackingCodeCallback }) => {
  const [value, setValue] = useState(row.trackingCode || "");

  useEffect(() => {
    setValue(row.trackingCode || "");
  }, [row.idRichiesta, row.trackingCode]);

  return (
    <Form>
      <div className="align-right no-print">
        <div className="row">
          {canManage && (
            <>
              <Form.Group className="col-xl-8 col-lg-8 col-sm-12 py-2 m-0">
                <input
                  id={`tracking-code-input-${row.idRichiesta}`}
                  label={`Tracking Code per ${row.idRichiesta}`}
                  type="text"
                  className="form-control form-control-solid"
                  placeholder="Inserisci Tracking Code"
                  value={value}
                  style={{ textAlign: "right" }}
                  onChange={(e) => setValue(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      e.stopPropagation();
                    }
                  }}
                />
              </Form.Group>
              <Form.Group className="col-xl-4 col-lg-4 col-sm-12 py-2 m-0">
                <OverlayTrigger overlay={<Tooltip>Applica il tracking code alla spedizione</Tooltip>}>
                  <span className="w-100 d-inline-block">
                    <Button
                      variant="warning"
                      className="w-100 my-2"
                      disabled={isRowLoading(row.idRichiesta)}
                      onClick={() => updateTrackingCodeCallback(row.idRichiesta, value)}
                      title="Applica Tracking Code"
                    >
                      <FontAwesomeIcon icon={faBox} className="svg-icon-white" style={{ marginRight: "0.5rem" }} />
                      <span className="text-white">Applica Tracking Code</span>
                    </Button>
                  </span>
                </OverlayTrigger>
              </Form.Group>
            </>
          )}
        </div>
        <div className="row mt-2">
          <div className="col-12">
            <OverlayTrigger overlay={<Tooltip>Apri pagina di tracking</Tooltip>}>
              <span className="w-100 d-inline-block">
                <Button
                  variant="success"
                  className="w-100 my-2"
                  disabled={String(value).trim() === ""}
                  onClick={() => {
                    const code = String(value).trim();
                    if (!code) return;
                    const url = `https://parcelsapp.com/it/tracking/${encodeURIComponent(code)}`;
                    window.open(url, "_blank", "noopener,noreferrer");
                  }}
                  title="Tracking"
                >
                  <FontAwesomeIcon icon={faTruck} className="svg-icon-white" style={{ marginRight: "0.5rem" }} />
                  <span className="text-white">Tracking</span>
                </Button>
              </span>
            </OverlayTrigger>
          </div>
        </div>
      </div>
    </Form>
  );
};

TrackingCodeInput.propTypes = {
  canManage: PropTypes.bool,
  row: PropTypes.shape({
    idRichiesta: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    trackingCode: PropTypes.string,
  }).isRequired,
  isRowLoading: PropTypes.func.isRequired,
  updateTrackingCodeCallback: PropTypes.func.isRequired,
};
export { TrackingCodeButton };
export default TrackingCodeInput;
